const navOptions = [
  { path: '/', text: 'Connect your car' },
  { path: '/guides/', text: 'Check compatibility' },
];

export default navOptions;
